<template>
    <div class="bind-phone">
        <!-- 绑定成功提示 -->
        <div v-if="isBound" class="success-section">
            <div class="success-content">
                <div class="success-icon">
                    <i class="el-icon-success"></i>
                </div>
                <div class="success-text">
                    <div class="success-title">手机号绑定成功</div>
                    <div class="success-desc">您的手机号 {{ userStore.userInfo.phone }} 已成功绑定</div>
                </div>
            </div>
        </div>

        <!-- 绑定表单 -->
        <div v-else>
            <!-- 友好提示 -->
            <div class="tip-section">
                <div class="tip-content">
                    <div class="tip-title"> <i class="el-icon-info"></i>建议绑定手机号</div>
                    <div class="tip-desc">绑定手机号后，您可以通过手机号快速重置密码，提高账户安全性</div>
                </div>
            </div>

            <!-- 绑定表单 -->
            <div class="form-section">
                <h4 class="section-title">
                    <i class="el-icon-mobile-phone"></i>
                    手机号绑定
                </h4>
                <el-form :model="dataForm" status-icon :rules="rules" ref="bindPhoneForm" label-width="80px" size="small">
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model="dataForm.phone" placeholder="请输入手机号码" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <div class="send-code-bar">
                            <el-input v-model="dataForm.code" placeholder="请输入验证码" maxlength="6"></el-input>
                            <div class="lock-text" v-if="lockTime > 0">{{ `${lockTime}秒后重新获取` }}</div>
                            <el-button v-else type="primary" plain size="small" @click="onSendSmsCode">获取验证码</el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="btn-group">
                    <el-button type="primary" @click="submitForm()">绑定</el-button>
                </div>
            </div>
        </div>
        <captcha-image ref="captchaRef"></captcha-image>
    </div>
</template>

<script>
import CaptchaImage from '../common/CaptchaImage.vue';

export default {
    name: "bindPhone",
    components: {
        CaptchaImage
    },
    data() {
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入手机号码'));
            }
            const regex = /^1[3-9]\d{9}$/;
            if (!regex.test(value)) {
                return callback(new Error('手机号格式错误'));
            }
            callback();
        };
        var checkCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入验证码'));
            }
            callback();
        };
        return {
            dataForm: {
                phone: '',
                code: ''
            },
            rules: {
                phone: [{
                    validator: checkPhone,
                    trigger: 'blur'
                }],
                code: [{
                    validator: checkCode,
                    trigger: 'blur'
                }]
            },
            lockTime: 0,
            lockTimer: null,
            isBound: false
        };
    },
    computed: {
        userStore() {
            return this.$root.userStore;
        }
    },
    methods: {
        init() {
            // 检查是否已绑定手机号
            this.isBound = !!this.userStore.userInfo.phone;
            if (!this.isBound) {
                // 初始化时清空表单
                this.dataForm.phone = '';
                this.dataForm.code = '';
                this.$refs.bindPhoneForm && this.$refs.bindPhoneForm.resetFields();
            }
        },
        submitForm() {
            this.$refs.bindPhoneForm.validate((valid) => {
                if (valid) {
                    this.$confirm('手机号码绑定后无法更改，是否绑定？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$http({
                            url: "/user/bindPhone",
                            method: 'PUT',
                            data: this.dataForm
                        }).then(() => {
                            this.$message.success("手机号码绑定成功");
                            this.userStore.userInfo.phone = this.dataForm.phone;
                            this.isBound = true; 
                        })
                    })
                }
            });
        },
        onSendSmsCode() {
            this.$refs.bindPhoneForm.validateField('phone', (valid) => {
                if (valid == '') {
                    // 发短信前先验证验证码，防止盗刷
                    this.$refs.captchaRef.open((id, code) => {
                        // 60s内不允许再次发送
                        this.lockTime = 60;
                        this.lockTimer && clearInterval(this.lockTimer);
                        this.lockTimer = setInterval(() => {
                            this.lockTime -= 1;
                            if (this.lockTime <= 0) {
                                this.lockTimer && clearInterval(this.lockTimer);
                            }
                        }, 1000)
                        // 发送短信
                        let data = {
                            phone: this.dataForm.phone,
                            id: id,
                            code: code
                        }
                        this.$http({
                            url: "/captcha/sms/code",
                            method: 'post',
                            data: data
                        }).then(() => {
                            this.$message.success("验证码已发送至您的手机，请注意查收")
                        }).catch((error) => {
                            this.$message.error(error.message || "发送验证码失败");
                            // 重置倒计时
                            this.lockTime = 0;
                            this.lockTimer && clearInterval(this.lockTimer);
                        })
                    });
                }
            })
        }
    },
    beforeDestroy() {
        // 清理定时器
        if (this.lockTimer) {
            clearInterval(this.lockTimer);
        }
    }
}
</script>

<style scoped lang="scss">
.bind-phone {
    padding: 18px 20px 24px;
    background: transparent;
    min-height: 400px;

    // 绑定成功提示 (glass-l2)
    .success-section {
        background: rgba(255, 252, 243, 0.78);
        backdrop-filter: blur(40px) saturate(160%);
        -webkit-backdrop-filter: blur(40px) saturate(160%);
        border: 0.5px solid rgba(255, 255, 255, 0.55);
        border-radius: var(--radius-lg);
        padding: 32px 30px;
        margin-bottom: 14px;
        box-shadow:
            inset 0 1px 0 0 rgba(255, 255, 255, 0.9),
            0 4px 12px rgba(31, 31, 35, 0.04),
            0 12px 32px rgba(31, 31, 35, 0.08);
        text-align: center;

        .success-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;

            .success-icon {
                width: 72px; height: 72px;
                border-radius: 50%;
                background: linear-gradient(135deg, rgba(52, 199, 89, 0.18), rgba(91, 141, 238, 0.10));
                display: flex; align-items: center; justify-content: center;
                box-shadow: 0 6px 20px rgba(52, 199, 89, 0.20);

                i {
                    font-size: 38px;
                    color: var(--im-color-success);
                }
            }

            .success-text {
                .success-title {
                    font-size: 18px;
                    font-weight: 700;
                    letter-spacing: -0.4px;
                    background: linear-gradient(135deg, var(--im-color-success), var(--aurora-blue));
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    margin-bottom: 6px;
                }

                .success-desc {
                    font-size: var(--im-font-size);
                    color: var(--im-text-color-light);
                }
            }
        }
    }

    .tip-section {
        display: flex;
        align-items: flex-start;
        padding: 14px 16px;
        margin-bottom: 16px;
        background:
            linear-gradient(135deg, rgba(91, 141, 238, 0.12), rgba(168, 139, 255, 0.08));
        border: 0.5px solid rgba(91, 141, 238, 0.30);
        border-radius: var(--radius-md);

        .tip-content {
            flex: 1;

            .tip-title {
                font-size: var(--im-font-size);
                font-weight: 600;
                color: var(--aurora-blue);
                margin-bottom: 4px;

                i {
                    font-size: 16px;
                    margin: 0 5px;
                }
            }

            .tip-desc {
                font-size: var(--im-font-size-small);
                color: var(--im-text-color-light);
                line-height: 1.5;
            }
        }
    }

    // 表单区域 (glass-l1)
    .form-section {
        background: rgba(255, 252, 243, 0.62);
        backdrop-filter: blur(24px) saturate(140%);
        -webkit-backdrop-filter: blur(24px) saturate(140%);
        border: 0.5px solid var(--glass-border);
        border-radius: var(--radius-md);
        padding: 16px 18px;
        margin-bottom: 14px;
        box-shadow:
            inset 0 1px 0 0 var(--glass-border-inner),
            0 1px 2px rgba(31, 31, 35, 0.04),
            0 8px 24px rgba(31, 31, 35, 0.06);

        .section-title {
            margin: 0 0 14px 0;
            font-size: 15px;
            font-weight: 600;
            letter-spacing: -0.3px;
            color: var(--im-text-color);
            display: flex;
            align-items: center;
            gap: 8px;
            padding-bottom: 10px;
            border-bottom: 0.5px solid var(--hairline-soft);

            i {
                color: var(--aurora-blue);
                font-size: 16px;
                background: linear-gradient(135deg, rgba(91, 141, 238, 0.14), rgba(168, 139, 255, 0.10));
                width: 26px; height: 26px;
                border-radius: 8px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
            }
        }
    }

    .send-code-bar {
        display: flex;
        align-items: center;
        gap: 8px;

        .el-input {
            flex: 1;
            min-width: 0;
        }

        .lock-text {
            font-size: var(--im-font-size-small);
            color: var(--im-text-color-light);
            white-space: nowrap;
            flex-shrink: 0;
        }
    }

    .btn-group {
        margin-top: 20px;
        display: flex;
        justify-content: center;

        .el-button {
            padding: 10px 36px;
            font-size: var(--im-font-size);
            font-weight: 600;
            min-width: 160px;
        }
    }
}
</style>
